module.exports = __webpack_public_path__ + "static/img/about3.4f08a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/about3.png
// module id = /QF+
// module chunks = 5